export class SapHanaRestoreProperties {
    'recoveryTimestamp';
    'hanaDbPassword';
    'hanaPort';
    'hanaSid';
    'hanaInstanceNumber';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "recoveryTimestamp",
            "baseName": "recoveryTimestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "hanaDbPassword",
            "baseName": "hanaDbPassword",
            "type": "string",
            "format": "password"
        },
        {
            "name": "hanaPort",
            "baseName": "hanaPort",
            "type": "number",
            "format": ""
        },
        {
            "name": "hanaSid",
            "baseName": "hanaSid",
            "type": "string",
            "format": ""
        },
        {
            "name": "hanaInstanceNumber",
            "baseName": "hanaInstanceNumber",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SapHanaRestoreProperties.attributeTypeMap;
    }
    constructor() {
    }
}
